import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import {
  SocialAuthService,
  FacebookLoginProvider,
  SocialUser
} from '@abacritt/angularx-social-login';
import { FacebookRegister, SocialProviderType } from 'src/app/interfaces/facebookRegister';
import { UserWithResponseStatus } from 'src/app/interfaces/user';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';

@Component({
  selector: 'app-facebook-login',
  templateUrl: './facebook-login.component.html',
  styleUrls: ['./facebook-login.component.scss']
})

export class FacebookLoginComponent implements OnInit {
  @Input() buttonSize?: string;
  public loading = false;
  @Output() newErrorEvent = new EventEmitter<string>();

  fbLoginOptions = {
    scope: 'email'
  };

  className = "btn btn-primary d-block d-md-inline-block mt-3 mt-md-1 facebook-login-button-width w-100"

  constructor(
    private _socialAuthService: SocialAuthService,
    private _authManagerService: AuthManagerService,
    private _router: Router
  ) { }

  ngOnInit() {
    if (this.buttonSize !== undefined) {
      this.className += " " + this.buttonSize;
    }
  }

  loginWithFacebook(): void {
    this.loading = true;
    this._socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID, this.fbLoginOptions)
      .then((user: SocialUser) => {
        const facebookRegister: FacebookRegister = {
          firstName: user.firstName,
          lastName: user.lastName,
          emailAddress: user.email,
          userSocialID: user.id,
          accessToken: user.authToken,
          socialProviderType: SocialProviderType.Facebook
        };

        this._authManagerService.loginWithFacebookUser(facebookRegister)
          .subscribe((response: UserWithResponseStatus) => {
              // new user was created
              if (response.responseStatus === 201) {
                this._router.navigateByUrl('/social-login-register', { state: response });
              // if the user has token, then we can navigate him to the dashboard
              } else if (response.responseStatus === 200 && response.token) {
                this._router.navigate(['/dashboard']);
              // if the user has no token but everything was OK, then
              // we navigate the user to the 'social-login-register' page
              } else if (response.responseStatus === 200 && !response.token) {
                this._router.navigateByUrl('/social-login-register', { state: response });
              }
            },
            err => {
              console.log('Error happened during the social login: ', err);
              if (err.error?.error_message) {
                this.newErrorEvent.emit(err.error.error_message);
              } else {
                this.newErrorEvent.emit(err.message);
              }
            }
          )
          .add(() => {
            this.loading = false;
          });
      });
  }

  signOut(): void {
    this._socialAuthService.signOut();
  }

}
